module.exports = __webpack_public_path__ + "static/music-city-bmx@2x-378bbd14680ecb091ef032b3f6da320a.png";